import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { utils } from '../../utils';
import { CustomField, CustomFieldModel, CreateCustomFieldData } from '../../types/customField';
import { EndpointResponse } from '../../types/endpoints';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  model: CustomFieldModel;
  data: CreateCustomFieldData;
};

type Response = CustomField;

const validate = (model: CustomFieldModel, data: CreateCustomFieldData) => {
  if (!model) {
    throw new Error('`model` is required');
  }
  if (!data) {
    throw new Error('`data` is required');
  }
  if (!data.name) {
    throw new Error('`data.name` is required');
  }
  if (!data.meta_field_type) {
    throw new Error('`data.meta_field_type` is required');
  }
};

export const createCustomField = async (
  scope: RequestScope,
  { model, data }: RequestParams,
  options: WriteRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    validate(model, data);

    // API expects the field payload directly (no `{ data: ... }` wrapper)
    const result = await scopedApi(scope).post<EndpointResponse<Response>>(`${model}/fields`, data, options);
    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
